import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

export { MapIndicator}

/**
 * Composant générique permettant l'affichage d'informations sur la map
 * 
 * @param {*} param0 
 * @returns 
 */
function MapIndicator ({info}) {
    const [isActive, setActive] = useState(info.isActive);    
    const showAllGeoloc = useSelector(state => state.vehicles.showAllGeoloc); 
    const { pathname } = useLocation();

    const handleClick = () => {
        setActive(!isActive);
        if (info.action){
            info.action();
        }
    }

    useEffect(() => {
        if(pathname === '/Geolocalisation' && !showAllGeoloc){
            setActive(false);
        }
    }, [showAllGeoloc])


    return (
        <button onClick={handleClick}>
            <div className={`key-number-global-container ${isActive ? info.isActiveClass : ""}`} >
                <div className={`key-number-icon bg-${info.color}`} >
                    <img src={info.icon}  alt={""}/>
                </div>
                <div className={`key-number-info ${isActive ? info.isActiveClass : ""}`}>
                    <div className={`key-number-value text-${isActive ? info.isActiveClass : info.color}`}>
                        {info.value}
                    </div>
                    <div className={`key-number-title text-${isActive ? info.isActiveClass : ""}`}>
                        {info.title}
                    </div>
                </div>
            </div>
        </button>
    )
}
